module.exports = __webpack_public_path__ + "YoungSerif-Regular.c1ddc79548c56154c22d.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/assets/fonts/YoungSerif-Regular.ttf
// module id = ../../../../../src-admin/assets/fonts/YoungSerif-Regular.ttf
// module chunks = styles